import React, { ChangeEvent, useEffect, useState } from "react";
import ShowAllStyles from "./ShowAll.styles";
import customTableStyles from "../../../../global/components/CustomTable/customTable.styles";
import { LicenseInfo } from "@mui/x-license-pro";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import {
  Box,
  Button,
  Divider,
  Grid,
  InputAdornment,
  Popover,
  Typography,
  Stack,
  IconButton,
  Autocomplete,
  TextField,
  FormControl,
  RadioGroup,
  Radio,
  FormControlLabel,
  FormLabel,
  TextareaAutosize,
  debounce,
  Skeleton,
  InputLabel,
  Select,
  MenuItem,
  Modal,
  Pagination,
  TableContainer,
  TableCell,
  TableRow,
  TableBody,
  Table,
  TableHead,
  Paper,
} from "@mui/material";
import {
  DateRange,
  LocalizationProvider,
  PickersShortcutsItem,
} from "@mui/x-date-pickers-pro";
import CustomInput from "../../../../global/components/CustomInput/CustomInput";
import Checkbox from "@mui/material/Checkbox";
import {
  DataGridPro,
  GridColDef,
  GridRenderCellParams,
  GridToolbarColumnsButton,
  GridToolbarContainer,
  GridToolbarExport,
  GridToolbarFilterButton,
  GridToolbarQuickFilter,
} from "@mui/x-data-grid-pro";
import { useDemoData } from "@mui/x-data-grid-generator";
import {
  debounceEventHandler,
  isTruthy,
  openErrorNotification,
  openSuccessNotification,
} from "../../../../helpers/methods";
import CustomButton from "../../../../global/components/CustomButton/CustomButton";
import { ReactComponent as CloseIcon } from "../../../../assets/icons/close.svg";
import AddNewTeam from "../AddNewTeam/AddNewTeam";
import AddNewTeam2 from "../customerProfile/customerView";
import {
  assignToMembers,
  changeAt,
  changeStage,
  changeStatusApi,
  getAllForms,
  getAllStage,
  getAllTeam,
  getAllTeamData,
  getAllTeamMembersData,
  getAllUsers,
  getDateWiseLead,
  getReminder,
  saveReminder,
} from "./ShowAllService";
import notifiers from "../../../../global/constants/NotificationConstants";
import SearchIcon from "@mui/icons-material/Search";
import CustomLoader from "../../../../global/components/CustomLoader/CustomLoader";
import CustomDialog from "../../../../global/components/CustomModal/CustomModal";
import CustomRadioButton from "../../../../global/components/CustomRadioButton/CustomRadioButton";
import customErrorHandler from "../../../../utils/customErrorHandler";
import AddLoan from "../AddLoan/AddLoan";
import LoanList from "../AddLoan/RoleTabContent";
import { store } from "../../../../utils/store";
import { ReactComponent as VerticalDotIcon } from "../../../../assets/icons/verticalDot.svg";
import {
  EmailOutlined,
  LocalPhone,
  Phone,
  WhatsApp,
} from "@mui/icons-material";
import { StaticDateRangePicker } from "@mui/x-date-pickers-pro/StaticDateRangePicker";
import dayjs, { Dayjs } from "dayjs";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import LeadDetailsComponent from "../../../../global/components/sidePanel/leadDetail";
import {
  getRemark,
  saveRemark,
} from "../../../MyLead/components/ShowAll/ShowAllService";
import { applyLicenseKey } from "../../../../utils/License";
import ReportStyles from "../../../Report/ReportStyle";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import paginationStyles from "../../../../global/components/CustomTable/Pagination.styles";
const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "80%",
  margin: "0 auto",
  bgcolor: "background.paper",
  border: "1px solid #e0e0e0",
  borderRadius: "4px",
  boxShadow: 24,
  p: 2,
};
const ShowAll = () => {
  // LicenseInfo.setLicenseKey(
  //   "74c3b9c03880c75b0883807cc9f17463Tz05OTMwMCxFPTE3NTk1NTk4NjAwMDAsUz1wcm8sTE09c3Vic2NyaXB0aW9uLFBWPVEzLTIwMjQsS1Y9Mg=="
  // );

  useEffect(() => {
    applyLicenseKey();
  }, []);
  const { data } = useDemoData({
    dataSet: "Commodity",
    rowLength: 10,
    editable: true,
  });
  const classes = ShowAllStyles;
  const customTableClasses = customTableStyles;
  const privileges = store.getState().auth?.privileges || {};
  const [userDataSource, setUserDataSource] = useState<any>([]);
  const [userDataSource1, setUserDataSource1] = useState<any>([]);
  const [page, setPage] = useState<number>(0);
  const [rowsPerPage, setRowsPerPage] = useState<number>(10);
  const [addNewTeamDialog, setNewTeamDialog] = useState<any>({
    open: false,
    edit: false,
  });
  const [customerDetails, setCustomerDetails] = useState<any>({
    open: false,
    edit: false,
  });
  const [exportNewTeamDialog, setExportTeamDialog] = useState<any>(false);
  const [getAddTeamMetaDataDylog, setGetAddTeamMetaDataDylog] =
    useState<boolean>(false);
  const [fixData, setFixData] = useState<any[]>([]);
  const [pageNumber, setPageNumber] = React.useState(0);
  const [eventForEdit, setEventForEdit] = React.useState();
  const userPerPage = 10;
  const [userId, setUserId] = useState("");
  const [status, setStatus] = useState("");
  const [apiResponse, setApiResponse] = useState(false);
  const [loading, setLoading] = useState(false);
  const loadingLinesCount = 20;
   const [remData, setRemData] = useState<any>([]);
  const [response, setResponse] = useState<any>();
  const [selectedUser, setSelectedUser] = useState({ id: "", status: 0 });
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [isDialogOpenLoan, setIsDialogOpenLoan] = useState<any>(false);
  const [isDialogOpenLoanList, setIsDialogOpenLoanList] = useState<any>(false);
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const [userRow_Id, setUserRow_Id] = useState<string>();
  const [rowStatus, setRowStatus] = useState();
  const [showSideBar, setShowSideBar] = useState(false);
  const [dynamicGridValue, setDynamicGridValue] = useState<any>();
  const [addinationalValue, setaddinationalValue] = useState<any>();
  const [leadOption, setLeadOption] = useState<any>([]);
  const [leadOptionMembers, setLeadOptionMembersas] = useState<any>([]);
  const [reminderStatus, setReminderStatus] = useState<any>("");
  const [reminderData, setReminderData] = useState<any>([]);
  const [responseValuereminder, setResponseValuereminder] = useState<any>([]);
  const [formName, setFormName] = useState<any>([]);
  const [tableData, setTableData] = useState<any>([]);
  const [stageData, setStageData] = useState<any>([]);
  const [selectedOptions, setSelectedOptions] = useState<any>([]);
  const [selectedOptionsMembers, setSelectedOptionsMembers] = useState<any>([]);
  const [responseValueremark, setResponseValueremark] = useState<any>([]);
  const [idForTeam, setIdForTeam] = useState<any>([]);
  const [idForMember, setIdForMember] = useState<any>([]);
  const [leadData, setLeadData] = useState<any>();
  const [offialDetailState, setOffialDetailState] = useState<any>({});

  const [selectedRows, setSelectedRows] = useState<any>([]);
  const [selectedDateRange, setSelectedDateRange] = useState<any>({});
  const [search, setSearch] = useState("");
  const [formLead, setFormLead] = useState<any>("");
  const [openView, setOpenView] = React.useState(false);
  const [showAssignPopup, setshowAssignPopup] = useState<any>({
    show: false,
    data: [],
  });
  const [metaData, setMetaData] = useState<any>({
    total: 1,
    page: 0,
  });
  const [openModal, setOpenModal] = useState<any>({
    name: "",
    data: {},
    open: false,
  });
  const [paginationModel, setPaginationModel] = React.useState({
    pageSize: 25,
    page: 0,
  });
  const [openDatePicker, setOpenDatePicker] = useState(false);
  const [anchorEDate, setAnchorEDate] = useState<null | HTMLElement>(null);

  const handleDateRangeChange = (newDateRange: any) => {
    if(newDateRange[0] ===null && newDateRange[1]===null){
      setOpenDatePicker(false);
      setAnchorEDate(null);
      setSelectedDateRange({ from:null, to:null });
      
    }else{

      const from = newDateRange[0]?.format("DD-MM-YYYY");
      const to = newDateRange[1]?.format("DD-MM-YYYY");
      if (from && to) {
        setOpenDatePicker(false);
        setAnchorEDate(null);
        setSelectedDateRange({ from, to });
      }
    }
  };
  useEffect(() => {
    tableDataShowHandler();
  }, []);
  useEffect(() => {
    tableDataShowHandler();
    console.log("heloopagination");
  }, [paginationModel]);

  useEffect(() => {
    tableDataShowHandler();
  }, [formLead]);

  useEffect(() => {
    if (Object.keys(offialDetailState)?.length) {
      tableDataShowHandler();
    }
  }, [offialDetailState]);
  useEffect(() => {
    if (Object.values(selectedDateRange)?.length === 2) {
      tableDataShowHandler();
    }
  }, [selectedDateRange]);

  interface LoadingTableLinesProps {
    numRows: number;
  }

  const handlePageSizeChange = (event: any) => {
    setPaginationModel({
      ...paginationModel,
      pageSize: event.target.value,
      page: 0,
    });
  };

  const openCustomer = () => {
    setUserId("");
    setCustomerDetails({
      open: true,
    });
  };
  const onClickHandlerExport = () => {
    setUserId("");
    setExportTeamDialog(true);
  };

  const handleEdit = (id: string) => {
    setNewTeamDialog({
      open: true,
      edit: true,
    });
    setUserId(id);
  };

  const handleCloseLoan = () => {
    setIsDialogOpenLoan(false);
  };

  const handleCloseLoanList = () => {
    setIsDialogOpenLoanList(false);
  };

  const filterLeadByForm = async (value: any) => {
    setFormLead(value);
  };

  const handlePopOver = (
    event: React.MouseEvent<HTMLButtonElement>,
    user_id: string,
    status: any,
    userData: any
  ) => {
    console.log(event, user_id, status, userData, "responseforadd");
    setAnchorEl(event.currentTarget);
    setUserRow_Id(user_id);
    setRowStatus(status);
    setEventForEdit(userData);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleCloseModal = () => {
    setOpenModal({
      name: "",
      data: {},
      open: false,
    });
  };
  const getReminderInfo = async (id: any) => {
    try {
      setApiResponse(true);
      const response = await getReminder(id);
      if (response.success == 1) {
        setResponseValuereminder((prevFormData: any) => ({
          ...prevFormData,
          [id]: {
            value: response?.data,
          },
        }));
      }
    } catch (error: any) {
      setApiResponse(false);
      openErrorNotification(
        isTruthy(error.message) ? error.message : notifiers.GENERIC_ERROR
      );
    }
  };
  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const handelDropdown = async (id: any) => {
    try {
      const response1 = await getAllTeamData(id?.id);
      setLeadOption(
        response1.data.map((e: any) => {
          return {
            id: e._id,
            label: e.team_name,
            selected: e?.is_available,
            teamMembers: e.team_members.length
              ? e.team_members.map((member: any) => {
                  return {
                    id: member.userId,
                    label: member.users[0].name,
                    selected: 0,
                  };
                })
              : null,
          };
        })
      );
      setSelectedOptions(
        response1.data
          .filter((e: any) => e?.is_available === 1)
          .map((e: any) => {
            return {
              id: e._id,
              label: e.team_name,
              selected: e?.is_available,
              teamMembers: e.team_members.length
                ? e.team_members.map((member: any) => {
                    return {
                      id: member.userId,
                      label: member.users[0].name,
                      selected: 0,
                    };
                  })
                : null,
            };
          })
      );

      const ids = response1.data
        .filter((e: any) => e?.is_available === 1)
        .map((e: any) => e._id);

      if (ids) {
        handelDropdownAfterSelect(ids);
      }
    } catch {}
  };

  const columns: GridColDef[] = [
    {
      headerName: "Lead",
      field: "leadName",
      filterable: true,
      minWidth: 350,

      flex: 1,
      renderCell: (params: GridRenderCellParams) => (
        <div
          onClick={() => {
            openCustomer();
            setLeadData(params.row);
          }}
        >
          <Stack
            direction="column"
            justifyContent="flex-start"
            alignItems="flex-start"
            spacing={1}
            className="action-button"
            data-action-button="true"
          >
            <Typography sx={classes.headerName}>
              {params.row?.leadName}
            </Typography>
            <Typography sx={classes.subHeaderName}>
              {params.row?.uid}
            </Typography>
          </Stack>
        </div>
      ),
    },
    {
      headerName: "Project",
      field: "property",
      minWidth: 300,
      flex: 1,
      renderCell: (params: GridRenderCellParams) => (
        <Stack
          direction="column"
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={1}
        >
          <Typography sx={classes.headerName}>
            {params.row.developer_name}
          </Typography>
          <Typography sx={classes.subHeaderName}>
            {params.row.project_name}
          </Typography>
          <Typography sx={classes.subHeaderName}>
            {params.row.projecttype_name}
          </Typography>
        </Stack>
      ),
    },

    {
      headerName: "Contact",
      field: "leadPhone",
      minWidth: 300,
      flex: 1,
      renderCell: (params: GridRenderCellParams) => (
        <Stack
          direction="column"
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={1}
        >
          <Typography sx={classes.centerText}>
            <EmailOutlined style={{ fontSize: "1rem" }} />
            {params.row.leadEmail}
          </Typography>
          <Typography
            sx={classes.centerText} 
          >
            {" "}
            <LocalPhone style={{ fontSize: "1rem" }} />
            {params.row?.leadPhone}
          </Typography>
        </Stack>
      ),
    },
    {
      headerName: "Reminder",
      field: "Reminder",
      minWidth: 150,
      flex: 1,
      // renderCell: (params: GridRenderCellParams) => (
      //   <Stack
      //     direction="column"
      //     justifyContent="flex-start"
      //     alignItems="flex-start"
      //     spacing={1}
      //   >
      //     {responseValuereminder?.[params?.row?._id]?.value && (
      //       <Box sx={classes.reminder}>
      //         {responseValuereminder?.[params?.row?._id]?.value[0]?.title
      //           ? "Reminder"
      //           : ""}
      //       </Box>
      //     )}
      //   </Stack>
      // ),

       renderCell: (params: GridRenderCellParams) => {
      
              const reminderData = remData?.find((item: any) => item?.leadId === params?.row?._id);
      
              if (reminderData?.date && reminderData?.time) {
                const reminderDateTimeString = `${reminderData?.date}T${reminderData?.time}`;
                const reminderDateTime = new Date(reminderDateTimeString);
      
                const currentDate = new Date();
      
                const isExpired = reminderDateTime < currentDate;
      
                return (
                  <Stack
                    direction="column"
                    justifyContent="flex-start"
                    alignItems="flex-start"
                    spacing={1}
                  >
                    {!isExpired ? (
                      <Box sx={classes.reminder1}>Reminder</Box>
                    ) : (
                      <Box sx={classes.expired}>Expired</Box>
                    )}
                  </Stack>
                );
              } else {
                return <Box sx={customTableClasses.empty}></Box>;
              }
            },
    },
    {
      headerName: "Source",
      field: "source",
      minWidth: 150,
      flex: 1,
      renderCell: (params: GridRenderCellParams) => (
        <Stack
          direction="column"
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={1}
        >
          <Typography sx={classes.subHeaderName}>
            {params.row?.source}
          </Typography>
        </Stack>
      ),
    },
    {
      headerName: "Stage",
      field: "stage",
      minWidth: 150,
      flex: 1,
      renderCell: (params: GridRenderCellParams) => (
        <Stack
          direction="column"
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={1}
        >
          <Box sx={classes.stageButton}>
            <button
              className="stageBtn"
              onClick={() => {
                setOpenModal({
                  name: "Stage Details",
                  data: {
                    stage: params?.row?.AssignToUserStage,
                    members: params.row?.AssignToUser,
                  },
                  open: true,
                });
              }}
              data-action-button="true"
            >
              Stages
            </button>
          </Box>
          {/* <Autocomplete
            className="action-button"
            data-action-button="true"
            style={{ width: "118px", backgroundColor: "#e7e7e7" }}
            disableClearable
            value={params?.row?.stage}
            onChange={(event: any, newValue: string | null) => {
              handleAutocompleteChange("stage", newValue || "", params.row);
            }}
            id="controllable-states-demo"
            options={stageData}
            sx={classes.autocomplateStyle}
            renderInput={(params) => (
              <TextField
                sx={classes.autoInputFill}
                {...params}
                placeholder="select your form name"
              />
            )}
            renderOption={(props, option) => {
              return (
                <li {...props} style={{ fontSize: "12px" }}>
                  <span style={{ display: "none" }}>{option}</span>
                  {option}
                </li>
              );
            }}
          /> */}
        </Stack>
      ),
    },
    {
      headerName: "Assigned To",
      field: "at",
      minWidth: 150,
      flex: 1,
      renderCell: (params: GridRenderCellParams) => (
        <Stack
          direction="column"
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={1}
          gap={"5px"}
        >
          <Box sx={classes.assignButton}>
            <button
              className="assignBtn"
              onClick={() => {
                setOpenModal({
                  name: "Assigne-To",
                  data: {
                    team: params.row?.AssignTo,
                    members: params.row?.AssignToUser,
                  },
                  open: true,
                });
              }}
              data-action-button="true"
            >
              {params.row?.AssignTo?.length}
            </button>
          </Box>
        </Stack>
      ),
    },
  ];
  const handleAutocompleteChange = async (
    name: string,
    value: any,
    data: any
  ) => {
    if (name === "stage") {
      const body = {
        ["id"]: data?._id,
        ["stage"]: value,
      };
      try {
        setApiResponse(true);
        const response = await changeStage(body);

        tableDataShowHandler();
      } catch (error: any) {
        setApiResponse(false);
        openErrorNotification(
          isTruthy(error.message) ? error.message : notifiers.GENERIC_ERROR
        );
      }
    }

    if (name === "assignTo") {
      const body = {
        ["id"]: data?._id,
        ["AssignTo"]: value?.id,
      };
      try {
        setApiResponse(true);
        const response = await changeAt(body);

        tableDataShowHandler();
      } catch (error: any) {
        setApiResponse(false);
        openErrorNotification(
          isTruthy(error.message) ? error.message : notifiers.GENERIC_ERROR
        );
      }
    }
    if (name === "formName") {
      if (value.label == "All") {
        tableDataShowHandler();
      }
      let data = response?.filter((e: any) => e.formId === value.id);
      console.log(response, ":::::RESPONSEEEEE", data, value.id);
      const source = data?.map((userData: any) => {
        return {
          lead: (
            <>
              <Typography sx={classes.headerName}>{userData?.uid}</Typography>
              <Typography sx={classes.headerName}>
                {userData?.leadName}
              </Typography>
            </>
          ),
          reminder: <>{getReminderInfo(userData._id)}</>,
          property: (
            <>
              <Typography sx={classes.subHeaderName}>
                {userData.projecttypeId}
              </Typography>
            </>
          ),
          contact: (
            <Typography sx={classes.subHeaderName}>
              {userData.leadEmail},{userData.leadPhone} <br />{" "}
              {userData.leadPhone}{" "}
            </Typography>
          ),
          formName: (
            <Typography sx={classes.subHeaderName}>
              {userData?.form_name}
            </Typography>
          ),
          source: (
            <>
              <Typography sx={classes.subHeaderName}>
                {userData?.source}
              </Typography>
            </>
          ),
          stage: (
            <>
              <Autocomplete
                disableClearable
                inputValue={userData?.stage ?? ""}
                onChange={(event: any, newValue: string | null) => {
                  handleAutocompleteChange("formId", newValue || "", userData);
                }}
                id="controllable-states-demo"
                options={stageData}
                sx={classes.autocomplateStyle}
                renderInput={(params) => (
                  <TextField
                    sx={classes.autoInputFill}
                    {...params}
                    placeholder="select your form name"
                  />
                )}
                renderOption={(props, option) => {
                  return (
                    <li {...props}>
                      <span style={{ display: "none" }}>{option}</span>
                      {option}
                    </li>
                  );
                }}
              />
            </>
          ),
          at: (
            <>
              {(userData.AssignTo ? userData.AssignTo : [])?.map(
                (item: any) => {
                  <Typography>{item.team_name}</Typography>;
                }
              )}
              {(userData.AssignToUser ? userData.AssignToUser : [])?.map(
                (item: any) => {
                  <Typography>{item?.name}</Typography>;
                }
              )}
            </>
          ),
        };
      });
      setUserDataSource([...source]);
      const source1 = data.map((userData: any) => {
        return userData;
      });
      setUserDataSource1([...source1]);
      setFixData([...source]);
      setApiResponse(false);
    }
  };
  const handelSideSave = async (body: any) => {
    try {
      setApiResponse(true);
      const response = await saveReminder(body);
      if ((response.sucess = 1)) {
      }
      tableDataShowHandler();
    } catch (error: any) {
      setApiResponse(false);
      openErrorNotification(
        isTruthy(error.message) ? error.message : notifiers.GENERIC_ERROR
      );
    }
  };
  const handelAssignToUser = async (dynamicGridValue: any) => {
    try {
      if (selectedOptionsMembers?.length) {
        const idTeam = selectedOptions.map((item: any) => {
          return `'${item.id}'`;
        });
        const body1 = {
          ["id"]: dynamicGridValue.row._id,
          ["AssignTo"]: idTeam.join(","),
        };
        // const response2 = await changeAt(body1);
        const idMembers = selectedOptionsMembers.map((item: any) => {
          return `'${item.id}'`;
        });
        const body = {
          ["id"]: dynamicGridValue.row._id,
          ["AssignToUser"]: idMembers.join(","),
        };

        const response = await assignToMembers(body);
        setIdForMember([]);
        setIdForTeam([]);
        setSelectedOptionsMembers([]);
        setSelectedOptions([]);
        setLeadOptionMembersas([]);
        tableDataShowHandler();
      } else {
        const idTeam = selectedOptions.map((item: any) => {
          return item.id;
        });
        const idTeamVal = idTeam.reduce(
          (val: any, item: any) => val + "," + `'${item}'`
        );
        const body1 = {
          ["id"]: dynamicGridValue.row._id,
          ["AssignTo"]: idTeamVal,
        };
        const response2 = await changeAt(body1);
        setIdForMember([]);
        setIdForTeam([]);
        setSelectedOptionsMembers([]);
        setSelectedOptions([]);
        setLeadOptionMembersas([]);
        tableDataShowHandler();
      }
    } catch (error: any) {}
  };
  const tableDataShowHandler = async () => {
    try {
      setApiResponse(true);

      setApiResponse(true);

      const response2 = await getAllStage();
      const val = response2.data.map((e: any) => {
        return e.status_name;
      });
      setStageData(val?.filter((name: any) => name !== "Initial"));

      const response3 = await getAllForms();

      setFormName(
        response3.data.map((i: any) => {
          return { id: i._id, label: i.form_name };
        })
      );
      const payload = {
        userId: store.getState().auth.userId,
        pageNo: paginationModel.page,
        pageSize: paginationModel.pageSize,
        search: search ? search : "",
        formId: formLead ? formLead : "",
        start_date : selectedDateRange.from  ? selectedDateRange.from  :"",
        end_date : selectedDateRange.to ? selectedDateRange.to : ""
      };
      const response = await getAllUsers(payload);
      console.log(response,'response');
      
      setLoading(true);
      setResponse(response.data);
      setMetaData(response?.metadata[0] ? response?.metadata[0] : []);
      const source = response.data.map((userData: any, index: any) => {
        return {
          lead: (
            <>
              <Typography sx={classes.headerName}>
                {userData?.leadName}
              </Typography>
              <Typography sx={classes.headerName}>{userData?.uid}</Typography>
            </>
          ),
          reminder: <>{getReminderInfo(userData._id)}</>,
          property: (
            <>
              <Typography sx={classes.subHeaderName}>
                {userData.projecttypeId}
              </Typography>
            </>
          ),
          contact: (
            <Typography sx={classes.subHeaderName}>
              {userData.leadEmail},{userData.leadPhone} <br />{" "}
              {userData.leadPhone}{" "}
            </Typography>
          ),
          formName: (
            <Typography sx={classes.subHeaderName}>
              {userData?.form_name}
            </Typography>
          ),
          source: (
            <>
              <Typography sx={classes.subHeaderName}>
                {userData?.source}
              </Typography>
            </>
          ),
          stage: (
            <>
              {userData.AssignToUserStage}
              {/* <Autocomplete
                disableClearable
                inputValue={userData?.stage ?? ""}
                onChange={(event: any, newValue: string | null) => {
                  handleAutocompleteChange("formId", newValue || "", userData);
                }}
                id="controllable-states-demo"
                options={stageData}
                sx={classes.autocomplateStyle}
                renderInput={(params) => (
                  <TextField
                    sx={classes.autoInputFill}
                    {...params}
                    placeholder="select your form name"
                  />
                )}
                renderOption={(props, option) => {
                  return (
                    <li {...props}>
                      <span style={{ display: "none" }}>{option}</span>
                      {option}
                    </li>
                  );
                }}
              /> */}
            </>
          ),
          at: (
            <>
              {userData?.AssignTo &&
                userData?.AssignTo?.map((item: any) => {
                  <Typography>{item.team_name}</Typography>;
                })}
            </>
          ),
        };
      });
      const arr = new Array(20);
      console.log(arr, "usedatasourrce");
      setUserDataSource([...source]);
      const source1 = response.data.map((userData: any) => {
        return userData;
      });
      setUserDataSource1([...source1]);
      setFixData([...source]);
      setApiResponse(false);
    } catch (error: any) {
      setApiResponse(false);
      openErrorNotification(
        isTruthy(error.message) ? error.message : notifiers.GENERIC_ERROR
      );
    }
  };
  console.log(userDataSource1, "usedatasourrce");
  const handleChangeRadio = (event: any) => {
    setReminderStatus(event.target.defaultValue);
  };
  const handleCloseAddTeam = () => {
    setshowAssignPopup({ show: false, data: [] });
  };
  const handleCloseExportTeam = () => {
    setExportTeamDialog(false);
    tableDataShowHandler();
  };

  const handleRadioChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedUser({ ...selectedUser, status: +event.target.value });
  };

  const dialogHeaderContent = () => {
    return (
      <Box marginTop={1} marginRight={3} sx={{ cursor: "pointer" }}>
        <CloseIcon onClick={() => setIsDialogOpen(false)} />
      </Box>
    );
  };

  const dialogTitleContent = () => {
    return (
      <>
        <Box sx={classes.content}>
          <Grid container>
            <Grid item xs={12}>
              <Typography sx={classes.pageHeading}>Account Status</Typography>
              <Typography sx={classes.pageSubHeading}>
                Change your account status
              </Typography>
            </Grid>

            <Grid item xs={12} mt={5}>
              <Typography sx={classes.statusHeading}>Current Status</Typography>

              <Box sx={classes.checkBoxWarapper}>
                <CustomRadioButton
                  value={1}
                  checked={selectedUser.status == 1}
                  onChange={handleRadioChange}
                  label="Active"
                />

                <CustomRadioButton
                  value={0}
                  checked={selectedUser.status == 0}
                  onChange={handleRadioChange}
                  label="Deactive"
                />
              </Box>
              <Box>
                <CustomButton
                  onClick={() => {}}
                  label="Delete Account"
                  buttonType="iconBtn"
                  customClasses={{ color: "red" }}
                />
              </Box>
            </Grid>
            <Grid item xs={12}>
              <Box sx={classes.buttonWrapperDialog}>
                <CustomButton
                  label="Save"
                  onClick={() => {}}
                  buttonType="primaryBtn"
                />
                <CustomButton
                  label="Cancel"
                  onClick={() => {
                    setIsDialogOpen(false);
                  }}
                  buttonType="secondaryBtn"
                />
              </Box>
            </Grid>
          </Grid>
        </Box>
      </>
    );
  };
  const handleAutocompleteChangeCustom = (newValue: any) => {
    const newlySelectedOptions = newValue.filter(
      (option: any) =>
        !selectedOptions.some(
          (selectedOption: any) => selectedOption.id === option.id
        )
    );
    const removedOptions = selectedOptions.filter(
      (option: any) =>
        !newValue.some((newOption: any) => newOption.id === option.id)
    );
    newlySelectedOptions.forEach((option: any) => {
      const ids = [option.id, ...selectedOptions.map((e: any) => e.id)];
      handelDropdownAfterSelect(ids);
      setIdForTeam((prev: any) => [...prev, option.id]);
      const opt = { ...option, selected: 1 };
      const objIndex = leadOption.findIndex(
        (item: any) => item.id === option.id
      );
      leadOption[objIndex] = opt;
      setLeadOption((prev: any) => [...prev, opt]);
      if (option.teamMembers) {
        setLeadOptionMembersas((prev: any) => [
          ...prev,
          ...option.teamMembers.map((member: any) => ({
            pId: option.id,
            id: member.id,
            label: member.label,
            selected: 0,
          })),
        ]);
      }
      setSelectedOptions((prev: any) => [...prev, opt]);
    });
    removedOptions.forEach((option: any) => {
      setSelectedOptions((prev: any) =>
        prev.filter((item: any) => item.id !== option.id)
      );
      setLeadOptionMembersas((prev: any) =>
        prev.filter((item: any) => item.pId !== option.id)
      );
      const opt = { ...option, selected: 0 };
      const objIndex = leadOption.findIndex(
        (item: any) => item.id === option.id
      );
      leadOption[objIndex] = opt;
      setLeadOption((prev: any) => [...prev]);
      setIdForTeam((prev: any) =>
        prev.filter((item: any) => item !== option.id)
      );
    });
  };
  const handelDropdownAfterSelect = async (ids: any) => {
    try {
      const payload = {
        team_id: ids,
        lead_id: dynamicGridValue?.id,
      };
      const response1 = await getAllTeamMembersData(payload);
      setLeadOptionMembersas(
        response1.data.flatMap((member: any) => {
          return member?.team_members?.map((mem: any) => {
            return {
              pId: member._id,
              id: mem.users[0]._id,
              label: mem.users[0]?.name,
              selected: mem?.is_available,
            };
          });
        })
      );
      setSelectedOptionsMembers(
        response1.data
          .flatMap((member: any) => {
            return member?.team_members?.map((mem: any) => {
              return {
                pId: member._id,
                id: mem.users[0]._id,
                label: mem.users[0]?.name,
                selected: mem?.is_available,
              };
            });
          })
          .filter((item: any) => item.selected === 1)
      );
    } catch {}
  };
  const handleOptionCheckboxChange =
    (option: any, value: any) => (event: any, index: any) => {
      if (event.target.checked) {
        const ids = [option.id, ...selectedOptions.map((e: any) => e.id)];
        handelDropdownAfterSelect(ids);
        setIdForTeam((prev: any) => [...prev, option.id]);
        const opt = { ...option, ["selected"]: 1 };
        const objIndex = leadOption.findIndex(
          (item: any) => item.id === option.id
        );
        leadOption[objIndex] = opt;
        setLeadOption((prev: any) => [...leadOption]);
        if (option.teamMembers) {
          setLeadOptionMembersas((prev: any) => {
            return [
              ...prev,
              ...option.teamMembers.map((member: any) => {
                return {
                  pId: option.id,
                  id: member.id,
                  label: member.label,
                  selected: 0,
                };
              }),
            ];
          });
        }
        setSelectedOptions([...selectedOptions, opt]);
      } else {
        setSelectedOptions(
          selectedOptions.filter((item: any) => item.id !== option.id)
        );
        setLeadOptionMembersas(
          leadOptionMembers.filter((item: any) => item?.pId !== option.id)
        );
        const opt = { ...option, ["selected"]: 0 };
        const objIndex = leadOption.findIndex(
          (item: any) => item.id === option.id
        );
        leadOption[objIndex] = opt;
        setLeadOption((prev: any) => [...leadOption]);
        setIdForTeam(idForTeam.filter((item: any) => item !== option?.id));
      }
    };
  const handleOptionCheckboxChange1 =
    (option: any, value: any) => (event: any, index: any) => {
      if (event.target.checked) {
        setIdForMember((prev: any) => [...prev, option.id]);
        const opt = { ...option, ["selected"]: 1 };
        const objIndex = leadOptionMembers.findIndex(
          (item: any) => item.id === option.id
        );
        leadOptionMembers[objIndex] = opt;
        setLeadOptionMembersas((prev: any) => [...leadOptionMembers]);
        setSelectedOptionsMembers([...selectedOptionsMembers, opt]);
      } else {
        setSelectedOptionsMembers(
          selectedOptionsMembers.filter((item: any) => item.id !== option.id)
        );
        const opt = { ...option, ["selected"]: 0 };
        const objIndex = leadOptionMembers.findIndex(
          (item: any) => item.id === option.id
        );
        leadOptionMembers[objIndex] = opt;
        setLeadOptionMembersas((prev: any) => [...leadOptionMembers]);
        setIdForMember(idForMember.filter((item: any) => item !== option?.id));
      }
    };
  const handleDateTimeChange = (event: any) => {
    const selectedDateTime = event.target.value;
    setReminderData((prevFormDataFields: any) => ({
      ...prevFormDataFields,
      ["date"]: event.target.value.split("T")[0],
      ["time"]: event.target.value.split("T")[1],
    }));
  };
  const handelDateRange = async (value: any) => {
    const from = value[0]?.format("DD/MM/yyyy");
    const to = value[1]?.format("DD/MM/yyyy");
    if (from && to) {
      try {
        const response = await getDateWiseLead(
          store.getState().auth.userId,
          from,
          to,
          paginationModel.page,
          paginationModel.pageSize
        );
        customErrorHandler(response);
        setResponse(response.data);
        const source = response.data.map((userData: any) => {
          return {
            leadName: (
              <>
                <Typography sx={classes.headerName}>
                  {userData?.leadName}
                </Typography>
                <Typography sx={classes.headerName}>{userData?.uid}</Typography>
              </>
            ),
            reminder: <>{getReminderInfo(userData._id)}</>,
            property: (
              <>
                <Typography sx={classes.subHeaderName}>
                  {userData.projecttypeId}
                </Typography>
              </>
            ),
            contact: (
              <Typography sx={classes.subHeaderName}>
                {userData.leadEmail},{userData.leadPhone} <br />{" "}
                {userData.leadPhone}{" "}
              </Typography>
            ),
            formName: (
              <Typography sx={classes.subHeaderName}>
                {userData?.form_name}
              </Typography>
            ),
            source: (
              <>
                <Typography sx={classes.subHeaderName}>
                  {userData?.source}
                </Typography>
              </>
            ),
            stage: (
              <>
                <Autocomplete
                  disableClearable
                  inputValue={userData?.stage ?? ""}
                  onChange={(event: any, newValue: string | null) => {
                    handleAutocompleteChange(
                      "formId",
                      newValue || "",
                      userData
                    );
                  }}
                  id="controllable-states-demo"
                  options={["New", "Old"]}
                  sx={classes.autocomplateStyle}
                  renderInput={(params) => (
                    <TextField
                      sx={classes.autoInputFill}
                      {...params}
                      placeholder="select your form name"
                    />
                  )}
                  renderOption={(props, option) => {
                    return (
                      <li {...props}>
                        <span style={{ display: "none" }}>{option}</span>
                        {option}
                      </li>
                    );
                  }}
                />
              </>
            ),
            at: (
              <>
                {userData.AssignTo?.map((item: any) => {
                  <Typography>{item.team_name}</Typography>;
                })}
                {userData?.AssignToUser?.map((item: any) => {
                  <Typography>{item?.name}</Typography>;
                })}
              </>
            ),
          };
        });
        setUserDataSource([...source]);
        const source1 = response.data.map((userData: any) => {
          return userData;
        });
        setUserDataSource1([...source1]);
        setFixData([...source]);
        setApiResponse(false);
      } catch (error: any) {
        setApiResponse(false);
        openErrorNotification(
          isTruthy(error.message) ? error.message : notifiers.GENERIC_ERROR
        );
      }
    }
  };
  function LoadingTableLines({ numRows }: LoadingTableLinesProps) {
    const loadingLines = Array.from({ length: 10 }, (_, index) => (
      <div key={index} style={{ marginBottom: "10px" }}>
        <Skeleton variant="rectangular" width="100%" height={10} />
      </div>
    ));

    return <>{loadingLines}</>;
  }
  useEffect(() => {
    tableDataShowHandler();
  }, [search]);

  const handleSearch = async (newValue: string) => {
    setSearch(newValue);
  };

  function CustomToolbar() {
    return (
      <GridToolbarContainer
        sx={{ width: "100%", justifyContent: "space-between" }}
      >
        <Box>
          {/* <GridToolbarQuickFilter />
          <GridToolbarFilterButton /> */}

          <TextField
            id="outlined-search"
type="search"
            placeholder="Search"
            variant="standard"
            value={search}
            onChange={(e) => handleSearch(e.target.value)}
            autoFocus
            sx={{
              width: "100%",
              fontSize: "12px",
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
          />
        </Box>
        {/* <Box sx={{ justifyContent: "end" }}>
          <GridToolbarColumnsButton />
        </Box> */}
      </GridToolbarContainer>
    );
  }

  const shortcutsItems: PickersShortcutsItem<DateRange<Dayjs>>[] = [
    {
      label: "This Week",
      getValue: () => {
        const today = dayjs();
        return [today.startOf("week"), today.endOf("week")];
      },
    },
    {
      label: "Last Week",
      getValue: () => {
        const today = dayjs();
        const prevWeek = today.subtract(7, "day");
        return [prevWeek.startOf("week"), prevWeek.endOf("week")];
      },
    },
    {
      label: "Last 7 Days",
      getValue: () => {
        const today = dayjs();
        return [today.subtract(7, "day"), today];
      },
    },
    {
      label: "Current Month",
      getValue: () => {
        const today = dayjs();
        return [today.startOf("month"), today.endOf("month")];
      },
    },
    {
      label: "Next Month",
      getValue: () => {
        const today = dayjs();
        const startOfNextMonth = today.endOf("month").add(1, "day");
        return [startOfNextMonth, startOfNextMonth.endOf("month")];
      },
    },
    {
      label: "Last Year",
      getValue: () => {
        const today = dayjs();
        const prevYear = today.subtract(1, "year");
        return [prevYear.startOf("year"), prevYear.endOf("year")];
      },
    },
    { label: "Reset", getValue: () => [null, null] },
  ];

  const handleSelectionChange = (newSelection: any) => {
    setSelectedRows(newSelection);
    // You can access the selected rows data here
    console.log("Selected Rows:", newSelection);
  };
  const handleChange = (value: any) => {
    console.log(value.target.value, "heloooValue");
    setPaginationModel({
      pageSize: value.target.value,
      page: paginationModel.page,
    });
  };
  const getRemarkInfo = async (id: any) => {
    try {
      // setApiResponse(true);
      const response = await getRemark(id);
      if (response.success == 1) {
        setResponseValueremark((prevFormData: any) => ({
          ...prevFormData,
          [id]: {
            value: response?.data,
          },
        }));
      }
    } catch (error: any) {
      setApiResponse(false);
      openErrorNotification(
        isTruthy(error.message) ? error.message : notifiers.GENERIC_ERROR
      );
    }
  };
  const handelSideSaveRemark = async (body: any) => {
    const payloade = {
      leadId: body.leadId,
      notes: body.notes_remark,
      date: new Date().toLocaleDateString(),
      time: new Date().toLocaleTimeString(),
      title: "",
    };
    console.log(body, ":::::HELLLOOO", payloade);
    try {
      setApiResponse(true);
      const response = await saveRemark(payloade);
      if ((response.sucess = 1)) {
        // setDynamicGridValue("");
      }
      setReminderData([]);
      getRemarkInfo(body.leadId);
      tableDataShowHandler();
    } catch (error: any) {
      setApiResponse(false);
      openErrorNotification(
        isTruthy(error.message) ? error.message : notifiers.GENERIC_ERROR
      );
    }
  };
  const getShowAllPage = () => {
    return (
      <>
        <Box
          sx={
            dynamicGridValue ? classes.showAllWrapper : classes.showAllWrapper1
          }
        >
          <Grid container>
            <Grid item xs={12}>
              <Grid container>
                <Grid item xs={12}  mt={2} mb={2}>
                  <Box sx={customTableClasses.menuPart}>
                  <Box sx={customTableClasses.selectBox}>
                    {/* <Box sx={classes.selectBox}>
                      <Autocomplete
                        disableClearable
                        value={tableData?.label}
                        defaultValue={"All"}
                        onChange={(event: any, newValue: string | null) => {
                          handleAutocompleteChange(
                            "formName",
                            newValue || "",
                            event
                          );
                        }}
                        id="controllable-states-demo"
                        options={[{ id: 0, label: "All" }, ...formName]}
                        sx={classes.autocomplateStyle}
                        renderInput={(params) => (
                          <TextField
                            sx={classes.autoInputFill}
                            {...params}
                            placeholder="select your form name"
                          />
                        )}
                        renderOption={(props, option) => {
                          return (
                            <li {...props} style={{ fontSize: "12px" }}>
                              <span style={{ display: "none" }}>
                                {option?.id}
                              </span>
                              {option?.label}
                            </li>
                          );
                        }}
                      />
                    </Box> */}
                    {/* <Box sx={classes.datePickerBox}>
                      <LocalizationProvider dateAdapter={AdapterMoment}>
                        <DateRangePicker
                          onChange={(newValue) => {
                            handelDateRange(newValue);
                          }}
                        />
                      </LocalizationProvider>
                    </Box> */}

                   
                    
                        <Autocomplete
                          value={tableData?.label}
                          defaultValue={"All"}
                          onChange={(event: any, newValue: any) => {
                            if (!newValue || newValue?.id === "all") {
                              filterLeadByForm("");
                            } else {
                              filterLeadByForm(!newValue || newValue.id || "");
                            }
                          }}
                          id="controllable-states-demo"
                          options={[
                            { label: "All", id: "all" },
                            ...formName.sort((a: any, b: any) =>
                              a.label.localeCompare(b.label)
                            ),
                          ]}
                          sx={classes.autocompleteStyle}
                          renderInput={(params) => (
                            <TextField
                              sx={classes.autoInputFill}
                              {...params}
                              placeholder="Select Form"
                            />
                          )}
                          renderOption={(props, option) => {
                            return (
                              <li {...props} style={{ fontSize: "12px" }}>
                                <span style={{ display: "none" }}>
                                  {option?.id}
                                </span>
                                {option?.label}
                              </li>
                            );
                          }}
                        />
                     

                     <TextField
                        value={
                          selectedDateRange?.from && selectedDateRange?.to
                            ? `${selectedDateRange.from} - ${selectedDateRange.to}`
                            : ""
                        }
                        onClick={(event) => {
                          setOpenDatePicker(true);
                          setAnchorEDate(event.currentTarget);
                        }}
                        sx={customTableClasses.dateFeild}
                        inputProps={{
                          style: { textAlign: 'center' },
                        }}
                        placeholder="MM/DD/YYYY - MM/DD/YYYY"
                      />
                      <Popover
                        open={openDatePicker}
                        anchorEl={anchorEDate}
                        onClose={() => {         
                          setOpenDatePicker(false)
                          setAnchorEDate(null);
                        }}
                        // sx={customTableClasses.datePopover}
                        anchorOrigin={{
                          vertical: 'bottom',
                          horizontal: 'left',
                        }}
                        transformOrigin={{
                          vertical: 'top',
                          horizontal: 'left',
                        }}
                      >
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <StaticDateRangePicker
                            onChange={handleDateRangeChange}
                            slotProps={{
                              shortcuts: {
                                items: shortcutsItems,
                              },
                              actionBar: { actions: [] },
                            }}
                            sx={customTableClasses.dateSelect}
                          />
                        </LocalizationProvider>
                      </Popover>
                    </Box>
                    <Box sx={customTableClasses.buttonArea}>
                      <CustomButton
                        buttonType="primaryBtn"
                        label="Assign Leads"
                        onClick={() => {
                          if (selectedRows?.length) {
                            setshowAssignPopup({
                              show: true,
                              data: selectedRows,
                            });
                          } else {
                            openErrorNotification("Please select Leads");
                          }
                        }}
                      />
                    </Box>
                  </Box>
                </Grid>
              </Grid>
              <Grid container>
                <Grid item xs={12}>
                  {loading ? (
                    <>
                     <Grid item xs={12} sx={customTableClasses.tableGridPart}>
                      {privileges &&
                      (privileges?.["All Lead"]?.includes("view") ||
                        privileges?.["All Lead"]?.includes("full control")) ? (
                       
                          <DataGridPro
                            columns={columns}
                            rows={userDataSource1}
                            getRowId={(row) => row._id}
                            rowHeight={95}
                            getRowClassName={(params) =>
                              `${customTableClasses.tableRow}`
                            }
                            sx={customTableClasses.gridRow}
                            onRowSelectionModelChange={handleSelectionChange}
                            checkboxSelection
                            density="compact"
                            rowsLoadingMode="server"
                            slots={{
                              toolbar: CustomToolbar,
                            }}
                            localeText={{
                              noRowsLabel: "No data found",
                            }}
                          />
                        
                      ) : (
                        ""
                      )}
                      <Popover
                        id={id}
                        open={open}
                        anchorEl={anchorEl}
                        sx={{ top: "10px", left: "-20px" }}
                        onClose={handleClose}
                        anchorOrigin={{
                          vertical: "bottom",
                          horizontal: "left",
                        }}
                      >
                        <Box sx={classes.innerPopOver}>
                          {privileges &&
                          (privileges?.["All Lead"]?.includes("edit") ||
                            privileges?.["All Lead"]?.includes(
                              "full control"
                            )) ? (
                            <CustomButton
                              label="Edit"
                              buttonType="iconBtn"
                              onClick={() => {
                                handleEdit(userRow_Id ?? "");
                              }}
                            />
                          ) : (
                            ""
                          )}
                        </Box>
                      </Popover>
                      </Grid>
                    </>
                  ) : (
                    <>
                      <LoadingTableLines numRows={loadingLinesCount} />
                    </>
                  )}
                  {/* <Box
                    style={{
                      position: "sticky",
                      width: "100%",
                      bottom: "0",
                      background: "#f7f7f7",
                      borderTop: "1px solid #E7E7EA",
                      padding: "5px",
                    }}
                  >
                    <div
                      style={{ display: "flex", justifyContent: "flex-end" }}
                    >
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <Select
                          style={{ fontSize: "12px" }}
                          labelId=""
                          id=""
                          value={paginationModel.pageSize}
                          label="Page Size"
                          onChange={handleChange}
                        >
                          <MenuItem value={10} style={{ fontSize: "12px" }}>
                            10
                          </MenuItem>
                          <MenuItem value={25} style={{ fontSize: "12px" }}>
                            25
                          </MenuItem>
                          <MenuItem value={50} style={{ fontSize: "12px" }}>
                            50
                          </MenuItem>
                          <MenuItem value={100} style={{ fontSize: "12px" }}>
                            100
                          </MenuItem>
                        </Select>

                        <div style={{ fontSize: "14px", margin: "0 20px" }}>
                          No of Pages -{" "}
                          {Math.round(
                            metaData?.total / paginationModel?.pageSize
                          )}
                        </div>
                        <Button
                          className={
                            paginationModel?.page === 0
                              ? "deActiveButton"
                              : "activeButton"
                          }
                          disabled={paginationModel?.page === 0}
                          onClick={() => {
                            setPaginationModel({
                              pageSize: paginationModel?.pageSize,
                              page: paginationModel?.page - 1,
                            });
                          }}
                        >
                          <ArrowBackIosNewIcon />
                        </Button>
                        <div style={{ fontSize: "14px", margin: "0 5px" }}>
                          {metaData?.page + 1}
                        </div>
                        <Button
                          className="activeButton"
                          onClick={() => {
                            setPaginationModel({
                              pageSize: paginationModel.pageSize,
                              page: paginationModel.page + 1,
                            });
                          }}
                        >
                          <ArrowForwardIosIcon />
                        </Button>
                      </div>
                    </div>
                  </Box> */}

                  <Box sx={paginationStyles.footer}>
                    <Box sx={paginationStyles.footerRight}>
                      <div style={{ marginRight: "8px" }}>Rows per page</div>

                      <FormControl size="small" sx={{ border: "none" }}>
                        <Select
                          value={paginationModel.pageSize}
                          onChange={handlePageSizeChange}
                          label="Page Size"
                          sx={{
                            fontSize: "11px",
                            border: "none",
                            minWidth: "60px",
                          }}
                        >
                          <MenuItem value={10} sx={paginationStyles.menuItem}>10</MenuItem>
                          <MenuItem value={25} sx={paginationStyles.menuItem}>25</MenuItem>
                          <MenuItem value={50} sx={paginationStyles.menuItem}>50</MenuItem>
                          <MenuItem value={100} sx={paginationStyles.menuItem}>100</MenuItem>
                          <MenuItem value={200} sx={paginationStyles.menuItem}>200</MenuItem>
                        </Select>
                      </FormControl>

                      <Pagination
                        count={Math.ceil(
                          metaData?.total / paginationModel.pageSize
                        )}
                        page={paginationModel.page + 1}
                        onChange={(event, value) => {
                          setPaginationModel({
                            ...paginationModel,
                            page: value - 1,
                          });
                        }}
                        size="small"
                        siblingCount={1}
                        boundaryCount={1}
                        sx={paginationStyles.font}
                      />
                    </Box>
                  </Box>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          {showAssignPopup?.show && (
            <AddNewTeam
              isDialogOpen={true}
              handleCloseAddTeam={handleCloseAddTeam}
              userId={userId}
              setUserId={setUserId}
              addNewTeamDialog={showAssignPopup}
              eventForEdit={eventForEdit}
            />
          )}

          {apiResponse && <CustomLoader apiResponse={false} />}
        </Box>
      </>
    );
  };

  return (
    <>
      <Grid container>
        <Grid item xs={dynamicGridValue ? 10 : 12}>
          {getShowAllPage()}
        </Grid>
{/* old code */}
        {/* <Modal
          open={openModal.open}
          onClose={handleCloseModal}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          style={{
            maxWidth: "700px",
            margin: "0 auto",
          }}
        >
          {openModal.name === "Stage Details" ? (
            <Box sx={style}>
              <div id="modal-modal-title">{openModal.name}</div>
              <Box>
                {openModal?.data?.stage?.map((item: any) => {
                  return (
                    <div
                      id="modal-modal-description"
                      style={{ display: "flex" }}
                    >
                      <div>
                        {
                          openModal?.data?.members.filter(
                            (e: any) => e._id === item.user_id
                          )[0]?.name
                        }
                      </div>
                      <div>-</div>
                      <div>{item.stage}</div>
                    </div>
                  );
                })}
              </Box>
            </Box>
          ) : (
            <Box sx={classes.popUpBox}>
              <div className="heading">Team List</div>
              <div>
                {openModal?.data?.team?.map((item: any) => {
                  return (
                    <div id="modal-modal-description" className="teamArea">
                      <div className="teamName">{item.team_name} -</div>
                      <div className="memberNameArea">
                        {openModal?.data?.members
                          ?.filter((member: any) => member.team_id === item._id)
                          ?.map((item: any, index: number) => {
                            return (
                              <div
                                id="modal-modal-description"
                                className="memberName"
                              >
                                {item.name}
                              </div>
                            );
                          })}
                      </div>
                    </div>
                  );
                })}
              </div>
            </Box>
          )}
        </Modal> */}


<Modal
  open={openModal.open}
  onClose={handleCloseModal}
  aria-labelledby="modal-modal-title"
  aria-describedby="modal-modal-description"
  style={{
    maxWidth: "700px",
    margin: "0 auto",
  }}
>
  {openModal.name === "Stage Details" ? (
            <Box sx={classes.popUpBox}>
            <div className="heading" style={{ fontWeight: "bold" }}>
              {openModal.name}
            </div>
            
            <TableContainer 
              component={Paper} 
              style={{
                maxHeight: "275px", 
                boxShadow: "none",
                overflowY: "auto",
scrollbarWidth:"thin",
              }}
            >
              <Table sx={{ width: "100%" }} stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell
                      style={{
                        width: "75%",
                        textAlign: "left",
                        fontSize: "14px",
                         fontWeight: "bold",
                        padding: "4px",
                        borderBottom: "1px solid #f1f1f1",
                      }}
                    >
                      Name
                    </TableCell>
                    <TableCell
                      style={{
                        width: "25%",
                        textAlign: "left", 
                        fontSize: "14px",
                         fontWeight: "bold",
                        padding: "4px",
                        borderBottom: "1px solid #f1f1f1",
                      }}
                    >
                      Stage
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
   {openModal?.data?.stage
     ?.filter((item: any) =>
       openModal?.data?.members.some((e: any) => e._id === item.user_id)
     )
     .map((item: any, index: number) => (
       <TableRow key={index} style={{ borderBottom: "1px solid #f1f1f1" }}>
         <TableCell
           style={{
             fontSize: "12px",
             padding: "4px",
           }}
         >
           {
             openModal?.data?.members.find((e: any) => e._id === item.user_id)
               ?.name
           }
         </TableCell>
         <TableCell
           style={{
             fontSize: "12px",
             padding: "8px",
           }}
         >
           {item.stage?.charAt(0).toUpperCase() + item.stage?.slice(1) || "New"}
         </TableCell>
       </TableRow>
     ))}
 </TableBody>
 
              </Table>
            </TableContainer>
          </Box>
          
           ) : openModal.name === "Reminder" ? (
             <Box sx={classes.popUpBox}>
               <div className="heading">Reminder</div>
             </Box>
           ): (
    <Box sx={classes.popUpBox}>
    <div className="heading" style={{ fontWeight: "bold" }}>
      Team List
    </div>
    <TableContainer
component={Paper}
style={{
maxHeight: "300px",
overflowY: "auto",
scrollbarWidth:"thin",
boxShadow: "none", 
}}
>
<Table sx={{ width: "100%" }} stickyHeader>
<TableHead>
<TableRow>
<TableCell
  style={{
    width: "50%",
    textAlign: "left",
    fontSize: "14px",
    fontWeight: "bold",
    padding: "8px",
    borderBottom: "1px solid #e0e0e0",
   
  }}
>
  Team Name
</TableCell>
<TableCell
  style={{
    width: "50%",
    textAlign: "left",
    fontSize: "16px",
    fontWeight: "bold",
    padding: "12px",
    borderBottom: "1px solid #e0e0e0",
 
  }}
>
  Team Members
</TableCell>
</TableRow>
</TableHead>
<TableBody>
{openModal?.data?.team?.map((item: any, index: number) => (
<TableRow
  key={index}
  style={{
    borderBottom: "1px solid #e0e0e0",
   
  }}
>
  <TableCell
    style={{
      fontSize: "12px",
      padding: "12px",
     
    }}
  >
    {item.team_name}
  </TableCell>
  <TableCell
    style={{
      fontSize: "14px",
      padding: "12px",
     
    }}
  >
    {openModal?.data?.members
      ?.filter((member: any) => {
        const teamIdArray = JSON.parse(member.team_id);
        return (
          Array.isArray(teamIdArray) && teamIdArray.includes(item._id)
        );
      })
      ?.map((member: any, idx: number) => (
        <div
          className="memberName"
          key={idx}
          style={{
            marginBottom: "4px",
            padding: "4px",
            
           
          }}
        >
          {member.name}
        </div>
      ))}
  </TableCell>
</TableRow>
))}
</TableBody>
</Table>
</TableContainer>




  </Box>
    // <Box sx={classes.popUpBox}>
    //   <div className="heading">Team List</div>
    //   <table style={{ width: "100%", border: "1px solid #f1f1f1" }}>
    //     <thead>
    //       <tr>
    //         <th
    //           style={{
    //             width: "25%",
    //             borderRight: "1px solid #f1f1f1",
    //             textAlign: "left",
    //             fontSize: "12px",
    //             padding: "4px",
    //           }}
    //         >
    //           Team Name
    //         </th>
    //         <th
    //           style={{
    //             width: "75%",
    //             textAlign: "left",
    //             fontSize: "12px",
    //             padding: "4px",
    //           }}
    //         >
    //           Members
    //         </th>
    //       </tr>
    //     </thead>
    //     <tbody>
    //       {openModal?.data?.team?.map((team: any) => (
    //         <tr key={team._id}>
    //           <td
    //             style={{
    //               borderTop: "1px solid #f1f1f1",
    //               borderRight: "1px solid #f1f1f1",
    //               fontSize: "12px",
    //               padding: "4px",
    //             }}
    //           >
    //             {team.team_name}
    //           </td>
    //           <td
    //             style={{
    //               borderTop: "1px solid #f1f1f1",
    //               fontSize: "12px",
    //               padding: "4px",
    //             }}
    //           >
    //             {openModal?.data?.members
    //               ?.filter((member: any) => member.team_id === team._id)
    //               ?.map((member: any, index: number) => (
    //                 <div key={index}>{member.name}</div>
    //               ))}
    //           </td>
    //         </tr>
    //       ))}
    //     </tbody>
    //   </table>
    // </Box>
  )}
</Modal>

      </Grid>
    </>
  );
};

export default ShowAll;
